export const ADVISORY_MANAGEMENT = 'advisory_management'
export const PATRIMONY_DECISION = 'patrimony_decision'
export const FREE_MANAGEMENT = 'free_management'
export const MIXED_MANAGEMENT = 'mixed_management'